import React from 'react';
import { Modal as AntModal } from 'antd';
import PropTypes from 'prop-types';
import forEach from 'lodash/forEach';

const Modal = props => {
  const attributes = {};
  forEach(props, (prop, propKey) => {
    if (propKey !== 'children') {
      attributes[propKey] = prop;
    }
  });

  return <AntModal {...attributes}>{props.children}</AntModal>;
};

Modal.defaultProps = {
  children: [],
  type: 'default',
};

Modal.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  type: PropTypes.string,
};

export default Modal;
